module.exports = __webpack_public_path__ + "img/icon5.579d87ae.png";